// extracted by mini-css-extract-plugin
module.exports = {"content":"location-map_content__21vIL","element":"location-map_element__1iqxY","map":"location-map_map__3TEiM","svg":"location-map_svg__fiifS"};